import { getCourseCategory } from '@/api/index2';

export default {
  namespaced: true,
  state: () => ({
    courseCategory: null,
    _pendingPromise: null,
  }),
  mutations: {
    setCourseCategory(state, value) {
      state.courseCategory = value;
    },
    clearCourseCategory(state) {
      state.courseCategory = null;
    },
  },
  actions: {
    async getCourseCategory({ commit, state }) {
      if (state.courseCategory) {
        return state.courseCategory;
      }
      if (state._pendingPromise) {
        return state._pendingPromise;
      }
      state._pendingPromise = (async () => {
        try {
          let param = { type: 1 };
          let res = await getCourseCategory(param);
          if (!res.data || !Array.isArray(res.data)) {
            throw new Error('无效的API响应结构');
          }
          const listFor = (arr) => {
            if (!Array.isArray(arr)) return [];
            return arr.map((item) => {
              const node = {
                value: item.id,
                label: item.name,
              };

              if (item.childCourseCategory && item.childCourseCategory.length) {
                node.children = listFor(item.childCourseCategory);
              }
              return node;
            });
          };
          let courseCategory = listFor(res.data);
          commit('setCourseCategory', courseCategory);
          return courseCategory;
        } finally {
          state._pendingPromise = null;
        }
      })();

      return state._pendingPromise;
    },

    async updateCourseCategory({ commit, dispatch }) {
      try {
        commit('clearCourseCategory');
        const courseCategory = await dispatch('getCourseCategory');
        return courseCategory;
      } catch (error) {
        console.error('课程分类刷新失败:', error);
        throw error;
      }
    },
  },
};
